import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ArrowLeftNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M18.9999 11C19.5521 11 19.9999 11.4477 19.9999 12Lnan nanL19.9999 12C19.9999 12.5523 19.5521 13 18.9999 13H7.99985L12.7899 17.79C13.182 18.1821 13.182 18.8179 12.7899 19.21Lnan nanL12.7899 19.21C12.3977 19.6021 11.762 19.6021 11.3699 19.21L5.57407 13.4142C4.79302 12.6332 4.79302 11.3668 5.57407 10.5858L11.3699 4.79C11.762 4.39788 12.3977 4.39788 12.7899 4.79Lnan nanL12.7899 4.79C13.182 5.18212 13.182 5.81788 12.7899 6.21L7.99985 11H18.9999Z'
            fill='currentColor'
        />
    </svg>
));
